import * as React from 'react';

import times from 'lodash/times';

import { StyleSheet, color, css, placeholder } from '@coursera/coursera-ui';

import BrowseCarousel from 'bundles/browse/components/non-cds/BrowseCarousel';
import { SCREEN_TABLET, responsiveProperty } from 'bundles/browse/constants';
import { BrowseProductCardPlaceholder } from 'bundles/payments-common/components/BrowseProductCard';

const styles = StyleSheet.create({
  collectionNamePlaceholder: {
    width: 400,
    height: 32,
    backgroundColor: color.gray,
    animationDelay: `${placeholder.animationDuration / 4}s`,
    [`@media (max-width: ${SCREEN_TABLET}px)`]: {
      width: 240,
    },
  },
});

type Props = {
  collectionItemHeight?: number;
  hideCollectionNameHeader?: boolean;
};

const Placeholder = ({ collectionItemHeight, hideCollectionNameHeader }: Props) => {
  const style = collectionItemHeight ? { height: collectionItemHeight } : {};
  return (
    <section className="rc-Collection placeholder">
      {!hideCollectionNameHeader && (
        <div {...css('collection-name', placeholder.styles.shimmer, styles.collectionNamePlaceholder)} />
      )}
      <BrowseCarousel style={style} responsive={responsiveProperty} slidesToShow={4} slidesToScroll={4}>
        {times(4, (i) => {
          return (
            <div className="rc-CollectionItem-wrapper" key={`placeholder-${i}`}>
              <BrowseProductCardPlaceholder />
            </div>
          );
        })}
      </BrowseCarousel>
    </section>
  );
};

export default Placeholder;
